exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-6098b449]{width:350px !important}.table .el-image[data-v-6098b449]{width:auto !important;height:30px !important}.table[data-v-6098b449] ::v-deepel-image__inner,.table .el-image__placeholder[data-v-6098b449],.table .el-image__error[data-v-6098b449]{width:auto !important}.info[data-v-6098b449]{width:63%}", ""]);

// exports
